import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

const PieCard = ({ 
  icon, 
  title, 
  data, 
  colors = ['#e65c00', '#36d576'],
  loading = false,
  breakdown = null // Optional breakdown data for detailed view
}) => {
  return (
    <div className="analytics-pie-card">
      <div className="analytics-pie-header">
        {icon}
        <div className="analytics-pie-title">{title}</div>
      </div>
      <div className="analytics-pie-content">
        <div className="analytics-pie-chart-container">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie 
                dataKey="value" 
                data={data} 
                cx="50%" 
                cy="50%" 
                outerRadius={50} 
                innerRadius={20}
                startAngle={90}
                endAngle={450}
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="analytics-pie-stats">
          {data.map((entry, index) => (
            <div key={entry.name} className="analytics-pie-stat">
              <div 
                className={`analytics-pie-stat-value analytics-pie-stat-${entry.name.toLowerCase()}`}
              >
                {loading ? '...' : entry.value}
              </div>
              <div className="analytics-pie-stat-label">{entry.name}</div>
              
              {/* Show breakdown if available */}
              {breakdown && breakdown[entry.name.toLowerCase()] && (
                <div style={{ 
                  fontSize: '10px', 
                  color: '#9ca3af', 
                  marginTop: '4px',
                  lineHeight: '1.2'
                }}>
                  <div style={{ color: '#dc2626' }}>
                    0 sec: {breakdown[entry.name.toLowerCase()].zeroSecond}
                  </div>
                  <div style={{ color: '#16a34a' }}>
                    &gt;0 sec: {breakdown[entry.name.toLowerCase()].nonZero}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PieCard;
